import { get } from 'lodash'
import { connect } from 'react-redux'

import { formData } from '../../../../constants/actions'
import withColorSetting from '../../../../hoc/withColorSettings'
import withUrlParams from '../../../../hoc/withUrlParams'
import {
  getCurrentRegistration,
  getFeeConfigurations,
  getFormSettings,
  getFormType,
  getOrgTimezones,
  getPaymentGateways,
  getSessionId,
} from '../../../../selectors'
import ProductComponent from './component'

const mapStateToProps = state => ({
  subEvents: get(state, 'formInfo.subEvents'),
  products: get(state, 'formInfo.products'),
  productGroups: get(state, 'formInfo.productGroups'),
  registrations: get(state, 'formData.registrations'),
  team: get(state, 'formInfo.team'),
  currentRegistration: getCurrentRegistration(state),
  sessionId: getSessionId(state),
  timezones: getOrgTimezones(state),
  formType: getFormType(state),
  feeConfigurations: getFeeConfigurations(state),
  paymentGateway: getPaymentGateways(state),
  formSettings: getFormSettings(state),
})

export default connect(mapStateToProps, {
  validateSession: formData.validateSession,
  setValue: formData.setValues,
})(withUrlParams(withColorSetting(ProductComponent)))
